// extracted by mini-css-extract-plugin
export var actionRow = "_nm-6";
export var card = "_nm-0";
export var chevron = "_nm-5";
export var content = "_nm-2";
export var details = "_nm-3";
export var eventActionToggle = "_nm-4";
export var icon = "_nm-1";
export var iconBlue = "_nm-8";
export var iconBrand = "_nm-7";
export var iconGrayBlue = "_nm-9";
export var iconGreen = "_nm-a";
export var iconIndigo = "_nm-b";
export var iconOrange = "_nm-c";
export var iconPurple = "_nm-d";
export var iconRed = "_nm-e";
export var iconWarning = "_nm-f";